import { createClient } from '@/shared/api';
import type {
  CreateTicketCommentInput,
  CreateTicketCommentMutation,
  CreateTicketCommentMutationVariables,
} from '@/shared/api';
import CREATE_TICKET_COMMENT from '../mutations/createTicketComment';

/**
 * Adds a comment to a support ticket. Runs the createTicketComment mutation and throws the returned message unless it reports success, otherwise yielding the created ticket comment.
 *
 * @param input - Mutation input describing the comment and its ticket.
 * @returns A promise resolving to the created ticket comment.
 */
const handleCreateTicketComment = async (input: CreateTicketCommentInput) => {
  const client = createClient();
  const result = await client.mutate<
    CreateTicketCommentMutation,
    CreateTicketCommentMutationVariables
  >({
    mutation: CREATE_TICKET_COMMENT,
    variables: { input },
  });
  const { isSuccess, message, ticketComment } = result.data?.createTicketComment || {};

  if (!isSuccess) {
    throw new Error(message ?? undefined);
  }
  return ticketComment;
};

export default handleCreateTicketComment;
